module.exports = __webpack_public_path__ + "static/media/not_found_page.b6fb607c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/not_found_page.jpg
// module id = 871
// module chunks = 0